import { render, staticRenderFns } from "./page-header-mobile.vue?vue&type=template&id=2c37668e&scoped=true"
import script from "./page-header-mobile.vue?vue&type=script&lang=js"
export * from "./page-header-mobile.vue?vue&type=script&lang=js"
import style0 from "./page-header-mobile.vue?vue&type=style&index=0&id=2c37668e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c37668e",
  null
  
)

export default component.exports